











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {OcorrenciaTracking} from '@/model/resource/OcorrenciaTracking'
import {OcorrenciaTrackingCollection} from '@/model/collection/OcorrenciaTrackingCollection'
import {ListOcorrenciaTrackingSchema} from '@/schema/resource/OcorrenciaTracking/ListOcorrenciaTrackingSchema'
import {CsvOcorrenciaTrackingSchema} from '@/schema/resource/OcorrenciaTracking/CsvOcorrenciaTrackingSchema'

@Component
export default class ListOcorrenciaTrackingView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListOcorrenciaTrackingSchema()
  collection = new OcorrenciaTrackingCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: OcorrenciaTracking) {
    Helper.pushByName(
      'editOcorrenciaTracking',
      item.idResponsavelFk,
      item.idCargaFk,
      item.idOcorrenciaFk as number
    )
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new OcorrenciaTrackingCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvOcorrenciaTracking()
    new CsvOcorrenciaTrackingSchema().downloadCsv(csv.all())
  }
}
